export const formatPhoneNumber = (num) => {
  const numString = num.toString().replace(/\D+/g, "");
  const regexpValid = /^[78]/.test(numString);
  const numLengthValid = numString.length === 11;
  if (regexpValid && numLengthValid) {
    return `+7 (${numString.substring(1, 4)}) ${numString.substring(
      4,
      7
    )}-${numString.substring(7)}`;
  }
  return num;
};

export const isPhoneValid = (num) => {
  const numString = num.toString().replace(/\D+/g, "");

  if (numString.length === 0) {
    return true;
  }

  return numString.length === 11;
};
